import styled from 'styled-components';
import { Checkbox, Col, ControlLabel, FormGroup, TagPicker } from 'rsuite';

export const ActionGridCol = styled(Col)`
  margin-top: 16px;
  padding-bottom: 8px;
  text-align: right;
  > .rs-btn {
    margin-top: 5px;
    margin-right: 10px;
  }
`;

export const StyledControlLabel = styled(ControlLabel)`
  font-size: 12px;
`;

export const StyledFormGroup = styled(FormGroup)`
  margin-top: 5px;
  margin-bottom: 5px;
  > .rs-form-control-wrapper {
    width: 100%;
  }
  &:not(:last-child) {
    margin-bottom: 6px !important;
  }
`;

export const ColumnsTagPicker = styled(TagPicker)`
  width: 100%;
  margin-top: 5px;
  margin-right: 10px;
  margin-bottom: 5px;
`;

export const IncludeAssocCheckbox = styled(Checkbox)`
  padding-right: 5px;
  border-radius: 6px;
  border: 1px solid #e5e5ea;
`;
